import React from "react";
import { useIntl } from "react-intl";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonCardHeader,
} from "@ionic/react";
import RadioButtonItem from "./formItems/RadioButtonItem";
import SelectItem from "./formItems/SelectItem";
import DateTimePicker from "./formItems/DateTimePicker";
import TextAreaItem from "./formItems/TextAreaItem";
import InputItem from "./formItems/InputItem";

export const Emergency = (props) => {
  const {
    control,
    loading,
    isFromVisitScreen, // is the component used in the patient or the visit screen? Depending on this we have slightly different behavior.
  } = props;

  const intl = useIntl();
  return (
    <IonCard>
      {/* the patient card handles the headers dynamically, the home visit doesn't */}
      {isFromVisitScreen &&
        <IonCardHeader>
          <IonCardTitle>
            {intl.formatMessage({
              id: "app.mobile.forms.house_visits.emergency_details",
            })}
          </IonCardTitle>
        </IonCardHeader>
      }
      <IonCardContent>
        <RadioButtonItem
          name={isFromVisitScreen ? "patient__emergency__stairs_to_street" : "emergency.stairs_to_street"}
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.emergency_stairs_to_street",
          })}
          disabled={!isFromVisitScreen}
          trueFalse={true}
          loading={loading}
        />

        <RadioButtonItem
          name={isFromVisitScreen ? "patient__emergency__has_chair_wheel" : "emergency.has_chair_wheel"}
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.emergency_has_chair_wheel",
          })}
          disabled={!isFromVisitScreen}
          trueFalse={true}
          loading={loading}
        />
        <RadioButtonItem
          name={isFromVisitScreen ? "patient__emergency__bound_to_bed" : "emergency.bound_to_bed"}
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.emergency_bound_to_bed",
          })}
          disabled={!isFromVisitScreen}
          trueFalse={true}
          loading={loading}
        />
        <RadioButtonItem
          name={isFromVisitScreen ? "patient__emergency__has_oxigen_generator" : "emergency.has_oxigen_generator"}
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.emergency_has_oxigen_generator",
          })}
          disabled={!isFromVisitScreen}
          trueFalse={true}
          loading={loading}
        />
        <RadioButtonItem
          name={isFromVisitScreen ? "patient__emergency__has_dialysis_machine" : "emergency.has_dialysis_machine"}
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.emergency_has_dialysis_machine",
          })}

          disabled={!isFromVisitScreen}
          trueFalse={true}
          loading={loading}
        />
        {isFromVisitScreen ?
          // From the home visit screen we need to be able to select, from the patient
          // card we just want to see. The control, however, doesn't let us see the current
          // value without pressing which you can't do if it's disabled
          <>
            <SelectItem
              rules={{
                required: `${intl.formatMessage({
                  id: "app.mobile.forms.patient.emergency_way_of_communication_id",
                })} ${intl.formatMessage({
                  id: "app.mobile.forms.requiredMessage",
                })}`,
              }}
              identfierId="id"
              name="patient__emergency__way_of_communication_id"
              control={control}
              label={intl.formatMessage({
                id: "app.mobile.forms.patient.emergency_way_of_communication_id",
              })}
              params={{
                name: "meta/system_tables/emergency_communication_ways",
              }}
              loading={loading}
            />
          </>
          : <>
            <InputItem
              name="emergency.way_of_communication.name"
              control={control}
              label={intl.formatMessage({
                id: "app.mobile.forms.patient.emergency_way_of_communication_id",
              })}
              disabled={true}
              loading={loading}
            />
          </>
        }
        <DateTimePicker
          rules={{
            required: `${intl.formatMessage({
              id: "app.mobile.forms.patient.emergency_guidance_date",
            })} ${intl.formatMessage({
              id: "app.mobile.forms.requiredMessage",
            })}`,
          }}
          name={isFromVisitScreen ? "patient__emergency__guidance_date" : "emergency.guidance_date"}
          disabled={!isFromVisitScreen}
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.emergency_guidance_date",
          })}
          loading={loading}
          presentation={"date"}
        />

        <TextAreaItem
          name={isFromVisitScreen ? "patient__emergency__supervision_description" : "emergency.supervision_description"}
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.emergency_supervision_description",
          })}
          loading={loading}
          rows={4}
          disabled={true}
        />
        <DateTimePicker
          required={false}
          name={isFromVisitScreen ? "patient__emergency__date_received_by_bl" : "emergency.date_received_by_bl"}
          disabled={true}
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.patient.emergency_date_received_by_bl",
          })}
          loading={loading}
          presentation={"date"}
        />
      </IonCardContent>
    </IonCard>
  );
};
